import { Icon, type Size } from "./Icon";

export function Checkbox({
  checked,
  size = 16,
}: {
  checked: boolean;
  size?: Size;
}) {
  return <Icon name={checked ? "check-filled" : "check-empty"} size={size} />;
}
